import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../app/store";

import { toast } from "react-toastify";
import { API_URL } from "../constants/apiUrl";
import { APP_API } from "../constants/constants";
import { setUserInfo, userLoggedIn } from "../features/auth/authSlice";
import { useFirstTimeLoginMutation } from "../features/portal/user/userApi";
import useError from "./useError";

export default function useProfile() {
  const dispatch = useAppDispatch();
  const { keycloak } = useKeycloak();
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(1);
  const [
    firstTimeLogin,
    {
      isLoading: isFirstTimeLoginLoading,
      isError: isFirstTimeLoginError,
      error: firstTimeLoginError,
      data: firstTimeLoginData,
      isSuccess: isFirstTimeLoginSuccess,
    },
  ] = useFirstTimeLoginMutation();
  useError(
    isFirstTimeLoginError,
    firstTimeLoginError,
    "Connected to server failed"
  );

  const reFatch = () => {
    setCount((tr) => tr + 1);
    console.log("reFatch");
  };

  const isSuperAdmin = keycloak?.realmAccess?.roles?.includes("super_admin");
  const isAdmin =
    keycloak?.realmAccess?.roles?.includes("admin") ||
    keycloak?.realmAccess?.roles?.includes("admin2");

  console.log(keycloak?.realmAccess?.roles);

  const isHRAdmin = keycloak?.realmAccess?.roles?.includes("hradmin2");

  useEffect(() => {
    if (keycloak?.token) {
      dispatch(userLoggedIn(keycloak?.token));
      if (keycloak?.tokenParsed?.email) {
        firstTimeLogin({
          email: keycloak?.tokenParsed?.email,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, keycloak?.token, keycloak?.tokenParsed?.email]);

  useEffect(() => {
    if (keycloak?.authenticated && keycloak?.token) {
      if (keycloak?.token) {
        dispatch(userLoggedIn(keycloak?.token));

        if (isFirstTimeLoginSuccess) {
          // fetch(`${APP_API}${API_URL.getMe}/${keycloak?.tokenParsed?.email}`, {
          fetch(`${APP_API}${API_URL.getMe}`, {
            method: "GET",
            // mode: "no-cors",
            headers: {
              Authorization: `Bearer ${keycloak?.token}`,
              "ngrok-skip-browser-warning": "true",
            },
          })
            .then((res) => res.json())
            .then((data) => {
              const loginUser = firstTimeLoginData?.data?.user;
              const mergedUserData = {
                ...data?.data,
                status: data?.data?.status ?? loginUser?.status,
                is_account_hold:
                  data?.data?.is_account_hold ?? loginUser?.is_account_hold,
              };

              // console.log("data", data);
              dispatch(
                setUserInfo({
                  ...data,
                  data: {
                    ...mergedUserData,
                    permission: isSuperAdmin
                      ? "SUPER_ADMIN"
                      : isAdmin
                      ? "Admin"
                      : isHRAdmin
                      ? "HR_ADMIN"
                      : mergedUserData?.permission,
                  },
                })
              );
              setLoading(false);
            })
            .catch((err) => {
              setLoading(false);
            });
        }
      }
    } else {
      setTimeout(() => {
        setLoading(false);
        // removeSession();
      }, 5000);
    }
  }, [
    dispatch,
    keycloak?.authenticated,
    keycloak?.token,
    keycloak?.tokenParsed?.email,
    isSuperAdmin,
    isAdmin,
    count,
    isFirstTimeLoginSuccess,
    isHRAdmin,
  ]);

  useEffect(() => {
    if (firstTimeLoginData?.data?.user?.is_account_hold) {
      toast.warning(
        "Account not verified. Ask your admin to verify your account to continue."
      );
    }
  }, [firstTimeLoginData?.data?.user?.is_account_hold]);

  return {
    loading: loading || isFirstTimeLoginLoading,
    reFatch,
  };
}
